import { TFunction } from 'i18next';

import { ENERGY_SOURCE } from '../../../../../PcfWizard.type';

type EnergySourceOption = { name: string; value: ENERGY_SOURCE; disabled: boolean };

/**
 * Sources already used by OTHER rows in this process are disabled (PAC-1617 AC3). `currentSource`
 * is excluded from that check so a row keeps showing its own already-picked source as selectable.
 */
export const getEnergySourceOptions = (
  t: TFunction,
  usedSources: Array<ENERGY_SOURCE | null | undefined> = [],
  currentSource?: ENERGY_SOURCE | null,
): EnergySourceOption[] => {
  const isUsedElsewhere = (source: ENERGY_SOURCE): boolean => {
    return source !== currentSource && usedSources.includes(source);
  };

  return [
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.electricity',
      ),
      value: ENERGY_SOURCE.ELECTRICITY,
      disabled: isUsedElsewhere(ENERGY_SOURCE.ELECTRICITY),
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.compressedAir',
      ),
      value: ENERGY_SOURCE.COMPRESSED_AIR,
      disabled: isUsedElsewhere(ENERGY_SOURCE.COMPRESSED_AIR),
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.gas',
      ),
      value: ENERGY_SOURCE.GAS,
      disabled: isUsedElsewhere(ENERGY_SOURCE.GAS),
    },
    {
      name: t(
        'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.energySourceOptions.fuel',
      ),
      value: ENERGY_SOURCE.FUEL,
      disabled: isUsedElsewhere(ENERGY_SOURCE.FUEL),
    },
  ];
};
